export enum State {
  TIMER = 'TIMER',
  WARNING = 'WARNING',
  WARNING2 = 'WARNING2',
  OVERTIME = 'OVERTIME',
}
